import { useState, useEffect } from "react";
import { Loader2, Film, Play } from "lucide-react";
import api from "@/lib/api";
import { RecordingPlayer, DownloadLink, fmtDur } from "@/components/recordings/RecordingPlayer";

export const MyRecordingsTab = () => {
  const [recs, setRecs] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/api/recordings").then(r => setRecs(r.data)).catch(() => setRecs([])); }, []);
  if (!recs) return <Loader2 className="w-6 h-6 animate-spin text-blue-600 mx-auto my-10" />;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm max-w-3xl" data-testid="my-recordings">
      <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2"><Film className="w-5 h-5 text-blue-600" />Meeting recordings</h2>
      <p className="text-sm text-slate-500 mb-4">Recordings your ShopAdvisor team has shared with you. Watch them any time or download a copy.</p>
      {recs.length === 0 ? <p className="text-sm text-slate-400 text-center py-8" data-testid="my-recordings-empty">No recordings shared with you yet.</p> : (
        <div className="divide-y divide-slate-100">{recs.map(r => (
          <div key={r.id} className="py-4" data-testid={`my-recording-${r.id}`}>
            <div className="flex flex-wrap items-center gap-3">
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-slate-900 truncate">{r.title}</p>
                <p className="text-xs text-slate-500">{new Date(r.created_at).toLocaleString()} · {fmtDur(r.duration_secs)}</p>
              </div>
              <button onClick={() => setOpen(open === r.id ? null : r.id)} className="inline-flex items-center gap-1 text-sm font-bold bg-blue-600 hover:bg-blue-500 text-white px-3 py-1.5 rounded-lg" data-testid={`my-recording-play-${r.id}`}><Play className="w-4 h-4" />{open === r.id ? "Hide" : "Watch"}</button>
              <DownloadLink rec={r} />
            </div>
            {open === r.id && <div className="mt-3"><RecordingPlayer rec={r} /></div>}
          </div>
        ))}</div>
      )}
    </div>
  );
};
